import React from "react"
import PropTypes from "prop-types"

const ContinueButton = props => (
  <button
    className="btn btn-yellow"
    data-bs-dismiss="modal"
    id="continue_button"
    type="button"
    {...props}
    onClick={e => !props.disabled && props.onClick?.(e)}
  >
    {props.children || "Let's Get Started"}
  </button>
)

ContinueButton.propTypes = {
  children: PropTypes.any,
  disabled: PropTypes.any,
  onClick: PropTypes.func,
}
export default ContinueButton
